module.exports = __webpack_public_path__ + "static/media/no-access.b0c15366.png";